import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectIsLoggedIn } from 'flow/selectors/app-selectors';

/** `useQuery` for endpoints that need a session — without one the request 401s and tears the app down. */
export var useAuthenticatedQuery = function useAuthenticatedQuery(options) {
  var _options$enabled;
  var isLoggedIn = useAppSelector(selectIsLoggedIn);
  return useQuery(_objectSpread(_objectSpread({}, options), {}, {
    // `enabled` may be a predicate in v5, so select rather than `&&`.
    enabled: isLoggedIn ? (_options$enabled = options.enabled) !== null && _options$enabled !== void 0 ? _options$enabled : true : false
  }));
};

/** As {@link useAuthenticatedQuery}, for paged endpoints. */
export var useAuthenticatedInfiniteQuery = function useAuthenticatedInfiniteQuery(options) {
  var _options$enabled2;
  var isLoggedIn = useAppSelector(selectIsLoggedIn);
  return useInfiniteQuery(_objectSpread(_objectSpread({}, options), {}, {
    enabled: isLoggedIn ? (_options$enabled2 = options.enabled) !== null && _options$enabled2 !== void 0 ? _options$enabled2 : true : false
  }));
};